/* file description */
import { Api as buiApi } from '@cui/req';


export function Api(config) {
  return buiApi({
    ...config,
    headers: {
      'Client-Time': new Date().valueOf(),
      ...config?.headers,
      ...Api.headers,
    },
  });
}
